<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoRetomar" persistent :max-width="Modal.Processamento.larguraMaxima">
            <v-list-tile-title slot="activator">
                <i class="fas fa-play-circle mr-2" aria-hidden="true"/>
                Retomar
            </v-list-tile-title>

            <modal-retomar-compra-direta ref="modalRetomar"
                                         v-model="dadosModal"
                                         :suspensaoPosAnalise="suspensaoPosAnalise"
                                         @salvarRetomada="tratarEventoRetomar"
                                         @fecharModalRetomada="tratarEventoFecharModal"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {actionTypes, Modal} from '@/core/constants'
import ModalRetomarCompraDireta from './ModalRetomarCompraDireta'

export default {
    name: 'AcoesRetomar',
    components: {ModalRetomarCompraDireta},
    props: {
        compraDiretaId: {
            required: true
        },
        suspensaoPosAnalise: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mostrarDialogoRetomar: false,
            processando: false,
            dadosModal: {},
            Modal
        }
    },
    methods: {
        async tratarEventoRetomar(objModal) {
            this.processando = true
            
            try {
                const objParaRetomar = {
                    compraDiretaId: this.compraDiretaId,
                    dados: {
                        motivoRetomada: objModal.motivo,
                        dataHoraInicioEnvioPropostas: objModal.dataHoraInicioEnvioPropostas,
                        dataHoraFimEnvioPropostas: objModal.dataHoraFimEnvioPropostas  
                    }
                }
                await this.$store.dispatch(actionTypes.RETOMAR_COMPRA_DIRETA, objParaRetomar)
                
                this.mostrarNotificacaoSucesso('Compra direta retomada com sucesso.')
                if (this.$refs.modalRetomar && this.$refs.modalRetomar.limparFormularioAposSalvar) {
                    this.$refs.modalRetomar.limparFormularioAposSalvar()
                }
                this.tratarEventoFecharModal()
                this.$emit('compraDiretaRetomada')
                
            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao retomar compra direta.')
            } finally {
                this.processando = false
            }
        },

        tratarEventoFecharModal() {
            this.mostrarDialogoRetomar = false
            this.dadosModal = {}
            this.processando = false
        }
    }
}
</script>

<style scoped>
.v-dialog__container {
    width: 100%;
}

.acoes {
    padding: 16px 24px;
}
</style>